// import Vue from 'vue'
import view from './inviteCode.vue'
// import VueI18n from 'vue-i18n';
// import zh from '@/config/zh.json';
// import en from '@/config/en.json';
import api from "@/api/api_list";

// Vue.use(VueI18n);
// const DEFAULT_LANG = 'en';
// // const DEFAULT_LANG = 'zh-cn';
// const locales = {
//   'zh-cn': zh,
//   en,
// };
// const i18n = new VueI18n({
//   locale: DEFAULT_LANG,
//   messages: locales,
// });

// const dialog = Vue.extend(view)
// let instance
// view.open = function(input={}) {

//   api.get_user_info()
//       .then(res=>{
//         if(res.code === 0){
//           let newUser = res.result.intgUser.newUser
//           if(newUser==1){
//             if(!instance){
//               instance = new dialog({
//                   i18n
//               }).$mount()
//             }
//             document.body.appendChild(instance.$el);
//             Vue.nextTick(() => {
//               instance.open(input);
//             });
//           }else{
//             let {bindComplete} = input
//             bindComplete ? bindComplete() : null;
//           }
//         }else{
//           let {bindComplete} = input
//           bindComplete ? bindComplete() : null;
//         }
//       })
//       .catch(function () {
//         let {bindComplete} = input
//         bindComplete ? bindComplete() : null;
//       })

//   };
// export default view

// 执行 未绑定成功的回调方法 - 此时不需要展示downloadGuide.vue
function invokiBindComplete( input ){
	let { bindComplete } = input
	bindComplete ? bindComplete( false ) : null;
}

export default {
	install(Vue, i18n) {
		const dialog = Vue.extend(view);

		let instance;

		view.open = async function (input = {}) {
				
			try{
				let res = await api.get_user_info()
				
				if (res.code === 0) {

					let newUser = res.result.intgUser.newUser;

					if (true) {

						if (!instance) {
							instance = new dialog({
								i18n
							}).$mount();
						}

						document.body.appendChild(instance.$el);

						Vue.nextTick(() => {
							instance.open(input);
						});

					} else {
						invokiBindComplete(input);
					}

				} else {
					invokiBindComplete(input);
				}
			}catch(e){
				invokiBindComplete(input);
			}

		};

		Vue.prototype.$bindInviteCode = view
	}
}